import React from "react";

const Field: React.FC<{
  label: string;
  value?: string | number | null;
  className?: string;
}> = ({ label, value, className = "" }) => (
  <div className={`mb-2 ${className}`}>
    <div className="text-xs text-gray-500 uppercase tracking-wide font-medium">
      {label}
    </div>
    <div className="text-sm text-gray-900 font-semibold mt-0.5">
      {value ?? "-"}
    </div>
  </div>
);

export default Field;
